import { Suspense, type JSX } from 'react'

import { ErrorBoundary } from 'react-error-boundary'

import PopularSearchesList, { PopularSearchesLoading } from './popular-searches-list'

import styles from './popular-searches.module.scss'

export default function PopularSearches({ close }: { close: () => void }): JSX.Element {
  return (
    <div className={styles['popular-searches']}>
      <h3>Popular Searches</h3>
      <div className={styles.wrap}>
        <ErrorBoundary fallback={<></>}>
          <Suspense fallback={<PopularSearchesLoading />}>
            <PopularSearchesList onClick={close} />
          </Suspense>
        </ErrorBoundary>
      </div>
    </div>
  )
}
